export enum DividerType {
  Vertical = 'vertical',
  Horizontal = 'horizontal'
}
